module.exports = __webpack_public_path__ + "img/wxTip.35118ea5.png";